export const permissions = {
  viewAdminUser: 'viewAdminUser',
  viewClientChild: 'viewClientChild',
  viewClient: 'viewClient',
  addClient: 'addClient',
  editClient: 'editClient',
  viewReport: 'viewReport',
  addReport: 'addReport',
  editReport: 'editReport',
  viewPlatform: 'viewPlatform',
  addPlatform: 'addPlatform',
  editPlatform: 'editPlatform',
  viewUser: 'viewUser',
  addUser: 'addUser',
  editUser: 'editUser',
  viewUserReports: 'viewUserReports',
  viewUserGroup: 'viewUserGroup',
  addUserGroup: 'addUserGroup',
  editUserGroup: 'editUserGroup',
  navBackClient: 'navBackClient',
  navBackUser: 'navBackUser',
  viewPlatformLog: 'viewPlatformLog',
  requestSupport: 'requestSupport',
  viewReportId: 'viewReportId',
  viewPowerBiId: 'viewPowerBiId',
  viewSurveyForm: 'viewSurveyForm',
  addSurveyForm: 'addSurveyForm',
  editSurveyForm: 'editSurveyForm',
  reInviteUser: 'reInviteUser',
  viewStaffDetails: 'viewStaffDetails',
  addStaffDetails: 'addStaffDetails',
  viewStaffMonthlyBudget: 'viewStaffMonthlyBudget',
  addStaffMonthlyBudget: 'addStaffMonthlyBudget',
  addscheduledreport: 'addscheduledreport',
  editschedulereport: 'editschedulereport',
  getscheduledreport: 'getscheduledreport',
  viewStaffData: 'viewStaffData',
  viewBilling: 'viewBilling',
  viewProjectStatus: 'viewProjectStatus',
  viewAdvisoryClient: 'viewAdvisoryClient',
  viewNotification: 'viewNotification',
  updateNotification: 'updateNotification',
  manageReportOptions: 'manageReportOptions',
  viewUpload: 'viewUpload',
  viewBas: 'viewBas',
  viewAdvisoryAI: 'viewAdvisoryAI',
  updateAdvisoryAI: 'updateAdvisoryAI',
  viewProfile: 'viewProfile',
  viewFileUpload: 'viewFileUpload',
  viewAnnualCompliance: 'viewAnnualCompliance',
  viewAgentBuilder: 'viewAgentBuilder',
  updateAgentBuilder: 'updateAgentBuilder',
  viewCapacityPlanner: 'viewCapacityPlanner',
  editCapacityPlanner: 'editCapacityPlanner',
  manageClaudeAccess: 'manageClaudeAccess',
} as const

export type PermissionKey = (typeof permissions)[keyof typeof permissions]

export enum UserTypes {
  Admin = 1,
  ClientAdmin = 2,
  ClientUser = 3,
  User = 4,
  Owner = 5,
  UnregisteredUser = 6,
  AdminAdvisor = 7,
}

export enum ClientTypes {
  Standard = 1,
  Restricted = 2,
  Advisor = 3,
}

export enum PlatformType {
  Xero = 1,
  XeroXpm = 2,
  XeroWorkflowMax = 3,
  Myob = 4,
  WorkGuru = 5,
  BRWFM = 6,
  Karbon = 7,
  FYI = 8,
  QuickBooks = 9,
}
